import React from "react";
import { Link, NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Dashboard", exact: true },
  { to: "/admin/interviews", label: "Interviews" },
  { to: "/admin/operators", label: "Operators" },
  { to: "/admin/topics", label: "Topics" },
  { to: "/admin/industries", label: "Industries" },
  { to: "/admin/collections", label: "Collections" },
  { to: "/admin/submissions", label: "Submissions" },
];

export default function AdminLayout() {
  const { user, checked, logout } = useAuth();
  const nav = useNavigate();
  const { pathname } = useLocation();

  React.useEffect(() => {
    if (checked && !user) nav("/admin/login", { replace: true });
  }, [checked, user, nav]);

  if (!checked || !user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="w-8 h-8 border-2 border-oc-ink border-t-transparent animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white text-oc-ink flex">
      <aside className="w-64 border-r border-oc-hairline min-h-screen sticky top-0 flex flex-col">
        <div className="p-6 border-b border-oc-hairline">
          <Link to="/" className="wordmark text-lg">
            Operating<span className="accent">/</span>Class
          </Link>
          <div className="eyebrow text-oc-ink-muted mt-2">Editorial Console</div>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.exact}
              data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `block px-4 py-2.5 font-ui text-sm font-semibold ${
                  isActive ? "bg-oc-ink text-white" : "text-oc-ink hover:bg-oc-sand"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-oc-hairline">
          <div className="font-ui text-xs text-oc-ink-muted mb-1">Signed in as</div>
          <div className="font-ui text-sm font-semibold">{user.email}</div>
          <button
            data-testid="admin-logout"
            onClick={() => { logout(); nav("/admin/login"); }}
            className="mt-3 inline-flex items-center gap-2 font-ui text-xs font-bold uppercase tracking-widest text-oc-coral hover:text-oc-ink"
          >
            <LogOut className="w-3.5 h-3.5" /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 p-8 md:p-12">
        <Outlet key={pathname} />
      </main>
    </div>
  );
}
